import { useState, useEffect } from 'react';
import GenericTable from './UI/reusable-components/GenericTable';
import Order from './UI/reusable-components/OrderComponents/Order';
import { CARGO_COMPANIES } from '../utils/constants';
import React from 'react';
import PropTypes from 'prop-types';
import invoiceService from '../services/invoicesService';
import useAlert from '../hooks/useAlert';
import { Button, CircularProgress, Backdrop } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { toast } from 'react-hot-toast';
import orderService from '../services/orderService.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketPlaces } from '../redux/actions/marketplacesActions';
import { getEcommercePlaces } from '../redux/actions/ecommercePlaceActions';
import { unwrapThunkList } from '../utils/helpers';
import { GetPrintTemplateSettingAction } from '../redux/actions/printTemplateSettingActions';

const DEFAULT_PRINT_SETTINGS = {
  showLogo: false,
  logoUrl: '',
  companyDisplayName: '',
  taxNumber: '',
  taxOffice: '',
  showTaxInfo: false,
  showOrderDate: true,
  showOrderNumber: true,
  showMarketplaceName: true,
  showStoreName: true,
  showCargoBarcode: true,
  showCargoCompany: true,
  showCampaignCode: true,
  showCustomerAddress: true,
  showCustomerEmail: false,
  showCustomerPhone: false,
  showProductImage: true,
  showProductDescription: true,
  showUnitPrice: false,
  showTotalPrice: false,
  showVat: false,
  customHeaderText: '',
  footerText: '',
};

export const Orders = (props) => {
  const { orders = [], totalOrders = 0, setSelectedOrder, isLoading: externalLoading } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [marketpleaces, setMarketpleaces] = useState([]);
  const [ecommerces, setEcommerces] = useState([]);
  const { showSuccessAlertAll, showErrorAlertAll } = useAlert();
  const [selectedData, setSelectedData] = useState([]);
  const [isPrinting, setIsPrinting] = useState(false);
  // State tanımlamaları
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filtersValue, setFiltersValue] = useState({});
  const [comboBoxFilter, setComboBoxFilter] = useState(null);
  const [selectedKdv, setSelectedKdv] = useState(null);
  const [filterFields, setFilterFields] = useState([
    { label: "Sipariş No", name: "OrderNumber", type: "text", value: null },
    {
      name: "dateRange",
      type: "dateRange",
      startName: "startDate",
      endName: "endDate",
      value: { startDate: null, endDate: null }
    },
    { label: "TCKN veya VKN", name: "Identifier", type: "text", value: null },
    { label: "Müşteri Adı", name: "customerFirstName", type: "text", value: null },
    { label: "Müşteri Soyadı", name: "customerLastName", type: "text", value: null },
  ]);
  const dispatch = useDispatch();

  // Kullanıcı ID'sini alıyoruz
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  // Header'daki seçili store bilgisini al
  const selectedStore = useSelector(state => state?.store?.selectedStoreName || '');

  useEffect(() => {
    setSelectedOrder(selectedData);
  }, [selectedData, setSelectedOrder]);

  const createInvoice = async () => {
    try {
      setIsLoading(true);

      const invoiceDataList = await Promise.all(
        selectedData.map(async (order) => {
          return await createInvoiceBody(order);
        })
      );
      await invoiceService.createRangeInvoice(invoiceDataList);
      showSuccessAlertAll();
      setIsLoading(false);
    } catch (exx) {
      showErrorAlertAll();
      setIsLoading(false);
      console.error("Toplu fatura oluşturma hatası:", exx);
    }
  };

  const createInvoiceBody = async (order) => {
    // InvoiceCustomerWD Name: Order'dan InvoiceCustomerFirstName/LastName null ise customerFirstName/LastName kullan
    const invoiceFirstName = (order.invoiceCustomerFirstName != null && order.invoiceCustomerFirstName !== '')
      ? order.invoiceCustomerFirstName
      : order.customerFirstName;
    const invoiceLastName = (order.invoiceCustomerLastName != null && order.invoiceCustomerLastName !== '')
      ? order.invoiceCustomerLastName
      : order.customerLastName;
    const invoiceCustomerWDName = `${invoiceFirstName || ''} ${invoiceLastName || ''}`.trim();

    const invoiceData = {
      userId: order.userId,
      orderId: order.id,
      recordType: 0,
      status: 0,
      profileType: 0,
      type: order.status == 4 || order.status == 5 ? 2 : 1,
      currencyCode: order.currencyCode || "TRY",
      paymentMeansCode: 48,
      note: "",
      totalAmount: parseFloat(order.totalPrice) || 0,
      invoiceRecordType: 2,
      ia: true,
      ettn: "",
      userOfCustomerId: 0,
      customerLastName: order.customerLastName,
      customerFirstName: order.customerFirstName,
      invoiced: true,
      invoiceCustomerWD: {
        name: invoiceCustomerWDName,
      },
      userOfCustomer: {
        userId: order.userId,
        type: 1,
        identifier: order.taxNumber || order.tcIdentityNumber,
        taxOffice: order.taxOffice || "",
        name: `${order.customerFirstName || ""} ${order.customerLastName || ""}`.trim(),
        mail: order.customerEmail || "",
        country: order.country || "TR",
        province: order.province || "",
        district: order.district || "",
        detail: order.address || "",
        ia: true
      },
      invoiceLines: (order.orderLines || []).map(item => ({
        ia: true,
        inventoryCard: item.productName || "",
        quantity: parseFloat(item.quantity) || 0,
        unitCode: "C62",
        price: parseFloat(item.price) || 0,
        vatRate:selectedKdv!=null ? selectedKdv: parseFloat(item.vatRate) || 0,
        lineExtensionAmount: parseFloat(item.amount) || 0,
        discountRate: 0,
        discountAmount: parseFloat(item.discountPrice) || 0,
        vatIncluded: true,
        description: item.productName || "",
        productId: item.productId || 0
      })),

      invoiceAddresses: (order.orderAddresses || []).map(item => ({
        type: item.adresType,
        addressDetail: item.addressDetail,
        orderId: order.id,
        ia: true,
        District: item.districtName,
        neighborhoodName: item.neighborhoodName || item.districtName,
        country: item.country,
        City: item.provinceName,
        provinceName: item.provinceName,
        name: order.customerFirstName,
        personSurName: order.customerLastName,
        identificationNumber: order.taxNumber || order.tcIdentityNumber,
        email: order.customerEmail,
      })),

      issueDate: new Date().toISOString(),
      paymentDueDate: new Date().toISOString()
    };

    // Return the invoice data
    return invoiceData;
  };
  // Tablo başlıkları
  const headers = [
    'Pazaryeri',
    'Durum',
    'Detay',
    'Sipariş No#',
    'Sipariş Tarihi',
    'Müşteri Bilgileri',
    'Mağaza/Kargo',
    'Sipariş Tutarı',
    'İşlem'
  ];

  // ComboBox filtreleri
  const comboBoxFilterFields = [
    { label: "Pazaryeri Platformları", name: "MarketPlaceId", options: marketpleaces },
    { label: "Eticaret Platformları", name: "EcommercePlaceId", options: ecommerces },
  ];

  // Filtre değerleri
  const filters = {
    OrderNumber: '',
    startDate: '',
    endDate: '',
    taxNumber: '',
    customerFirstName: '',
    customerLastName: '',
    store: '',
    cargo: '',
    salesChannel: '',
    priceRange: [0, 0],
    tckn: null
  };

  // Handler fonksiyonları
  const handleOnSearchFilters = async (filters) => {
    try {
      setIsLoading(true);
      setFiltersValue(filters);
      setCurrentPage(1);

      // onFiltersChange prop kontrolü ve çağrılması
      if (typeof props.onFiltersChange === 'function') {
        props.onFiltersChange(filters);
      }
    } catch (error) {
      console.error('Filtreleme sırasında hata:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = async (newPage) => {
    try {
      setIsLoading(true);
      const maxPage = Math.max(1, Math.ceil(totalOrders / pageSize) || 1);
      if (newPage === 1 || (newPage >= 1 && newPage <= maxPage)) {
        setCurrentPage(newPage);

        // onPageChange prop kontrolü ve çağrılması
        if (typeof props.onPageChange === 'function') {
          props.onPageChange(newPage);
        }
      }
    } catch (error) {
      console.error('Sayfa değişimi sırasında hata:', error);
      setCurrentPage(currentPage);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageSizeChange = async (newPageSize) => {
    try {
      setIsLoading(true);
      if (newPageSize > 0) {
        setPageSize(newPageSize);
        setCurrentPage(1);

        // onPageSizeChange prop kontrolü ve çağrılması
        if (typeof props.onPageSizeChange === 'function') {
          props.onPageSizeChange(newPageSize);
        }
      }
    } catch (error) {
      console.error('Sayfa boyutu değişimi sırasında hata:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {

        // marketyerlerini yükle
        const markeresponse = await dispatch(getMarketPlaces(token));
        const marketList = unwrapThunkList(markeresponse);
        setMarketpleaces(
          marketList.map((x) => ({
            value: x.id,
            label: x.name,
          }))
        );

        const ecommerceResponse = await dispatch(getEcommercePlaces(token));
        const ecommerceList = unwrapThunkList(ecommerceResponse);
        setEcommerces(
          ecommerceList.map((x) => ({
            value: x.id,
            label: x.name,
          }))
        );
      } catch (error) {
        console.error("Filtre seçenekleri yüklenirken hata oluştu:", error);
      }
    };

    fetchFilterOptions(); // Tedarikçi ve kategori bilgilerini yükle
  }, []);

  // Bu kodu handlePrint fonksiyonuna entegre etmelisiniz

  const handlePrint = async () => {
    const selectedStore = localStorage.getItem('selectedStoreName') || '';
    if (!selectedData || selectedData.length === 0) {
      toast.warning('Lütfen yazdırmak için en az bir sipariş seçin');
      return;
    }

    try {
      setIsPrinting(true);

      // Seçili siparişlerin ID'lerini al
      const orderIds = selectedData.map(order => order.id);

      // Tüm siparişleri fetchOrdersWithProduct ile tekrar çek
      const [response, printTemplateList] = await Promise.all([
        orderService.fetchOrdersWithProduct(authUserId,
          currentPage,
          pageSize,
          false,
          filtersValue),
        dispatch(GetPrintTemplateSettingAction(authUserId)).catch(() => []),
      ]);

      const printSettings = (printTemplateList && printTemplateList.length > 0)
        ? { ...DEFAULT_PRINT_SETTINGS, ...printTemplateList[0] }
        : DEFAULT_PRINT_SETTINGS;

      if (!response || !response.status) {
        toast.error('Siparişler alınamadı');
        setIsPrinting(false);
        return;
      }

      // Sadece seçili ID'lere sahip siparişleri filtrele
      const updatedOrderData = response.data?.data?.filter(order => orderIds.includes(order.id));

      if (!updatedOrderData.length) {
        toast.error('Seçilen siparişler için güncel veri bulunamadı');
        setIsPrinting(false);
        return;
      }

      // Her sipariş için ayrı sayfa oluştur
      const orderGroups = updatedOrderData.map(order => [order]);

      // Yazdırma için iframe oluştur
      const printFrame = document.createElement('iframe');
      printFrame.style.position = 'fixed';
      printFrame.style.right = '0';
      printFrame.style.bottom = '0';
      printFrame.style.width = '0';
      printFrame.style.height = '0';
      printFrame.style.border = '0';
      document.body.appendChild(printFrame);

      const printContent = `
     <!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Siparişleri Yazdır</title>
  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
  <style>
    @page {
      size: A4;
      margin: 0;
    }
    html, body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
    }
    .page {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      page-break-after: always;
      position: relative;
      padding: 0;
    }
    body {
      font-family: Arial, sans-serif;
      font-size: 16px;
      line-height: 1.7;
    }
    .order-container {
      border: 1px solid #000;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .header-logo {
      max-height: 35px;
      max-width: 180px;
      width: auto;
      height: auto;
      object-fit: contain;
    }
    .date-header {
      display: flex;
      justify-content: space-between;
      padding: 10px 18px;
      font-size: 15px;
      border-bottom: 1px solid #000;
    }
    table td {
      padding: 10px 12px !important;
      font-size: 16px !important;
    }
    .product-section {
      padding: 15px;
      border-bottom: 1px solid #000;
      flex-grow: 0;
    }
    .product-item {
      margin-bottom: 20px;
      overflow: hidden;
    }
    .product-image {
      width: 150px;
      height: 150px;
      object-fit: cover;
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .product-info {
      font-size: 17px;
      margin-bottom: 12px;
      font-weight: 500;
    }
    .product-description {
      font-size: 15px;
      line-height: 1.7;
    }
    .barcode-container {
      text-align: center;
      padding: 15px;
      border-top: 1px solid #000;
      flex-grow: 0;
      position: relative;
    }
    .barcode-value {
      margin-top: 1px;
      font-family: monospace;
      font-size: 18px;
      font-weight: bold;
    }
    .page-number {
      font-size: 14px;
      font-weight: bold;
    }
    .footer-text {
      font-size: 13px;
    }
    .content-area {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  </style>
</head>
<body>
  ${orderGroups.map((group, groupIndex) => {
    const orderDetails = group[0];
    const orderDate = orderDetails.orderDate ? new Date(orderDetails.orderDate).toLocaleDateString('tr-TR') : '';
    const deliveryAddress = orderDetails.orderAddresses && orderDetails.orderAddresses.length > 0
      ? orderDetails.orderAddresses.find(addr => addr.adresType === 1)?.addressDetail || ''
      : orderDetails.address || '';
    const currentDate = new Date().toLocaleDateString('tr-TR');
    const currentTime = new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

    return `
      <div class="page">
        <div class="order-container">
          ${(printSettings.showLogo && printSettings.logoUrl) || printSettings.companyDisplayName ? `
          <div style="display:flex; align-items:center; justify-content:space-between; padding:8px 18px; border-bottom:1px solid #000;">
            ${printSettings.showLogo && printSettings.logoUrl ? `<img src="${printSettings.logoUrl}" class="header-logo" />` : '<span></span>'}
            ${printSettings.companyDisplayName ? `<strong style="font-size:16px;">${printSettings.companyDisplayName}</strong>` : ''}
          </div>` : ''}
          <div class="date-header">
            <div><strong>${currentDate} ${currentTime}</strong></div>
            <div><strong>${printSettings.customHeaderText || 'Siparişleri Yazdır'}</strong></div>
          </div>

          <table style="width:100%; border-collapse:collapse; margin:0; padding:0;">
            ${printSettings.showMarketplaceName ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Pazaryeri:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.marketPlace?.name || orderDetails.ecommercePlaceName || ''}</strong></td>
            </tr>` : ''}
            ${printSettings.showStoreName ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Mağaza:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${selectedStore}</strong></td>
            </tr>` : ''}
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Alıcı Ad / Soyad:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.customerFirstName || ''} ${orderDetails.customerLastName || ''}</strong></td>
            </tr>
            ${printSettings.showCustomerAddress ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Alıcı Adres:</td>
              <td style="border:1px solid #000; font-size:17px;">${deliveryAddress}</td>
            </tr>` : ''}
            ${printSettings.showCustomerEmail && orderDetails.customerEmail ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Alıcı E-posta:</td>
              <td style="border:1px solid #000; font-size:17px;">${orderDetails.customerEmail}</td>
            </tr>` : ''}
            ${printSettings.showCustomerPhone && orderDetails.customerPhone ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Alıcı Telefon:</td>
              <td style="border:1px solid #000; font-size:17px;">${orderDetails.customerPhone}</td>
            </tr>` : ''}
            ${printSettings.showOrderDate ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Sipariş Tarihi:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDate}</strong></td>
            </tr>` : ''}
            ${printSettings.showOrderNumber ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Sipariş Numarası:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.orderNumber || ''}</strong></td>
            </tr>` : ''}
            ${printSettings.showTaxInfo && (printSettings.taxNumber || printSettings.taxOffice) ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Vergi Bilgileri:</td>
              <td style="border:1px solid #000; font-size:17px;">${printSettings.taxNumber || ''}${printSettings.taxNumber && printSettings.taxOffice ? ' / ' : ''}${printSettings.taxOffice || ''}</td>
            </tr>` : ''}
            ${printSettings.showCargoCompany ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Kargo Firması:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.cargoCompany || orderDetails.cargoProviderName || ''}</strong></td>
            </tr>
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Kargo Takip No:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.cargoTrackingNumber || ''}</strong></td>
            </tr>` : ''}
            ${printSettings.showTotalPrice && orderDetails.totalPrice ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Toplam Tutar:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${Number(orderDetails.totalPrice).toFixed(2)} ${orderDetails.currencyCode || 'TRY'}</strong></td>
            </tr>` : ''}
            ${orderDetails.campaignCode && printSettings.showCampaignCode ? `
            <tr>
              <td style="width:180px; border:1px solid #000; font-weight:bold; font-size:17px;">Kampanya Kodu:</td>
              <td style="border:1px solid #000; font-size:17px;"><strong>${orderDetails.campaignCode}</strong></td>
            </tr>` : ''}
          </table>

          <div class="content-area">
            <div class="product-section">
              ${(orderDetails.orderLines && orderDetails.orderLines.length > 0) ? `
                ${orderDetails.orderLines.map(line => `
                  <div class="product-item">
                    ${printSettings.showProductImage ? `
                    <img
                      src="${line.productImage || 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png'}"
                      alt="${line.productName || 'Ürün'}"
                      referrerpolicy="no-referrer"
                      class="product-image"
                      onerror="this.src='https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png'; this.onerror=null;"
                    />` : ''}
                    <div class="product-info">
                      <strong>Ürün Adı:</strong> ${line.productName || ''}
                      <strong style="margin-left: 15px;">Adet:</strong> x${line.quantity || '1'}
                      ${printSettings.showUnitPrice && line.price ? `<strong style="margin-left: 15px;">Birim Fiyat:</strong> ${Number(line.price).toFixed(2)} ${orderDetails.currencyCode || 'TRY'}` : ''}
                      ${printSettings.showVat && (line.vatRate || line.vatRate === 0) ? `<strong style="margin-left: 15px;">KDV:</strong> %${line.vatRate}` : ''}
                    </div>
                    ${printSettings.showProductDescription ? `
                    <div class="product-description"><strong>Açıklama:</strong> ${(() => {
                      const desc = line.productDescription || 'Ürün bilgisi bulunamadı';
                      const temp = document.createElement('div');
                      temp.innerHTML = desc;
                      const cleanDesc = temp.textContent || temp.innerText || '';
                      return cleanDesc.length > 1850 ? cleanDesc.substring(0, 1850) + '...' : cleanDesc;
                    })()}</div>` : ''}
                    <div style="clear:both;"></div>
                  </div>
                `).join('')}
              ` : 'Ürün bilgisi bulunamadı'}
            </div>

            ${printSettings.showCargoBarcode ? `
            <div class="barcode-container">
              <svg id="barcode-${orderDetails.id}" style="width:80%;"></svg>
              <div class="barcode-value"><strong>${orderDetails.cargoTrackingNumber || ''}</strong></div>
            </div>` : ''}
          </div>

          <div style="position: absolute; bottom: 8px; left: 10px;" class="footer-text">${printSettings.footerText || 'localhost:5173/orders'}</div>
          <div style="position: absolute; bottom: 8px; right: 10px;" class="page-number">${groupIndex + 1}/${orderGroups.length}</div>
        </div>
      </div>
    `;
  }).join('')}
  
  <script>
    let hasStartedPrinting = false;
    window.onload = function() {
      if (hasStartedPrinting) return;
      hasStartedPrinting = true;

      ${printSettings.showCargoBarcode ? updatedOrderData.map(orderDetails => {
        const barcodeValue = orderDetails.cargoTrackingNumber || '';
        return `
          try {
            const barcodeValue = "${barcodeValue}";
            if (barcodeValue) {
              JsBarcode("#barcode-${orderDetails.id}", barcodeValue, {
                format: "CODE128",
                width: 2,
                height: 40,
                displayValue: false,
                margin: 10
              });
            } else {
              document.querySelector('#barcode-${orderDetails.id}').parentElement.style.display = 'none';
            }
          } catch (e) {
            console.error('Barkod oluşturma hatası:', e);
            document.querySelector('#barcode-${orderDetails.id}').parentElement.style.display = 'none';
          }
        `;
      }).join('') : ''}

      window.onafterprint = function() {
        window.parent.postMessage('printComplete', '*');
      };

      setTimeout(() => {
        window.print();
      }, 800);
    };
  </script>
</body>
</html>

    `;

      const handlePrintMessage = (event) => {
        if (event.data === 'printComplete') {
          document.body.removeChild(printFrame);
          setIsPrinting(false);
          window.removeEventListener('message', handlePrintMessage);
        }
      };

      window.addEventListener('message', handlePrintMessage);

      printFrame.contentDocument.open();
      printFrame.contentDocument.write(printContent);
      printFrame.contentDocument.close();

      printFrame.onload = function () {
        if (printFrame.contentWindow.hasStartedPrinting) return;
        printFrame.contentWindow.hasStartedPrinting = true;
      };

      toast.success(`${updatedOrderData.length} sipariş yazdırılmaya hazırlanıyor`);
    } catch (error) {
      console.error('Yazdırma hatası:', error);
      toast.error('Yazdırma işlemi sırasında bir hata oluştu');
      setIsPrinting(false);
    }
  };

  const tableButtons = [
    <Button
      key="print-button"
      variant="contained"
      onClick={handlePrint}
      disabled={!selectedData || selectedData.length === 0}
      startIcon={<PrintIcon />}
      sx={{
        textTransform: "none",
        fontWeight: 500,
        backgroundColor: "#1F1B45",
        "&:hover": {
          backgroundColor: "#2c2766",
        },
        padding: '8px 32px'
      }}
    >
      Yazdır
    </Button>
  ];

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isPrinting}
      >
        <div style={{ textAlign: 'center' }}>
          <CircularProgress color="inherit" />
          <div style={{ marginTop: 10, color: 'white', fontWeight: 'bold' }}>
            Yazdırma hazırlanıyor...
          </div>
        </div>
      </Backdrop>
      <GenericTable
        data={orders}
        headers={headers}
        filterFields={filterFields}
        setFilterFields={setFilterFields}
        filterLogic={(_order) => true}
        RowComponent={Order}
        filters={filters}
        comboBoxFilterFields={comboBoxFilterFields}
        fieldsToClear={filters}
        rangeInputFilterFields={[]}
        setFiltersValue={setFiltersValue}
        onSearchFilters={handleOnSearchFilters}
        setComboBoxFilter={setComboBoxFilter}
        comboBoxFilter={comboBoxFilter}
        // Pagination props
        currentPage={currentPage}
        setCurrentPage={handlePageChange}
        pageSize={pageSize}
        setPageSize={handlePageSizeChange}
        totalItems={Number(totalOrders) || 0}
        isLoading={isLoading || externalLoading}
        genericFunction={createInvoice}
        setSelectedData={setSelectedData}
        selectedData={selectedData}
        tableButtons={tableButtons}
        setSelectedKdv={setSelectedKdv}
        selectedKdv={selectedKdv}
      />
    </>
  );
};

Orders.propTypes = {
  orders: PropTypes.array,
  totalOrders: PropTypes.number,
  setSelectedOrder: PropTypes.func.isRequired,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onFiltersChange: PropTypes.func,
  isLoading: PropTypes.bool
};

export default Orders;